import React, { forwardRef } from "react"

import { Icon } from "@/components"

import { useStyles } from "@/components/SelectItemWithIcon/SelectItemWithIcon.styles"

type ItemProps = {
    label: string
    value: string
    icon: string
} & React.ComponentPropsWithoutRef<"div">

export const SelectItemWithIcon = forwardRef<HTMLDivElement, ItemProps>(
    ({ label, icon, className, ...restProps }: ItemProps, ref) => {
        const { classes, theme, cx } = useStyles()

        return (
            <div
                {...restProps}
                ref={ref}
                className={cx(className, classes.item)}
                role="option"
                aria-selected={restProps["aria-selected"]}
            >
                <Icon icon={icon} color={restProps["data-selected"] ? theme.white : theme.colors.gray[7]} />
                {label}
            </div>
        )
    },
)
